// extracted by mini-css-extract-plugin
module.exports = {"countdown":"fj","srOnly":"gj"};